import React from "react";
import "./App.css";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Heroslider from "./Pages/Heroslider";
import SolidWasteManagement from "./Services/SolidWasteManagement";
import Biomedical from "./Services/BioMedicalWasteManagement";
import Hazardous from "./Services/HazardousWasteManagement";
import Faecal from "./Services/Faecal Sludge Management";
import Manpower from "./Services/ManpowerServicesandStaffing";
import Liquidwastemanagement from "./Services/Liquidwastemanagement";
import Conservancyservices from "./Services/Conservancyservices";
import Securityservices from "./Services/Securityservices";
import Facilitymanagement from "./Services/Facilitymanagement";
import {  Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Construction from "./Services/Construction";
import Team from "./Pages/Team";
import Products from "./Pages/Products";
import Career from "./Pages/Career";
import Blog from "./Pages/Blog";
import BlogDetail from "./Pages/BlogDetail";
import AdminLogin from "./Pages/AdminLogin";
import AdminDashboard from "./Pages/AdminDashboard";
import Contact from "./Pages/Contact";
import PhotoVideo from "./Pages/Photo&Video";
import Rain from "./Blogdetails/Rain";
import Energy from "./Blogdetails/Energy";
import Industrial from "./Blogdetails/Industrial";
import Environmental from "./Blogdetails/Environmental";
import Packaging from "./Blogdetails/Packaging";
import Food from "./Blogdetails/Food";
import useSeoMetadata from "./useSeoMetadata";
import useGoogleAnalytics from "./useGoogleAnalytics";



function App() {
  useSeoMetadata();
  useGoogleAnalytics();

  return (
    <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solid-waste-management" element={<SolidWasteManagement />} />
          <Route path="/hazardous-waste-management" element={<Hazardous />} />
          <Route path="/bio-medical-waste-management" element={<Biomedical />} />
          <Route path="/faecal-sludge-waste-management" element={<Faecal />} />
          <Route path="/manpower-services-and-staffing" element={<Manpower />} />
          <Route path="/construction" element={<Construction />} />
          <Route path="/liquid-waste-management" element={<Liquidwastemanagement />} />
          <Route path="/conservancyservices" element={<Conservancyservices />} />
          <Route path="/securityservices" element={<Securityservices />} />
          <Route path="/facilitymanagement" element={<Facilitymanagement />} />
          <Route path="/products" element={<Products />} />
          <Route path="/career" element={<Career />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/" element={<Heroslider />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/photos-and-videos" element={<PhotoVideo />} />
          <Route path="/rain" element={<Rain />} />
          <Route path="/energy" element={<Energy />} />
          <Route path="/industrial" element={<Industrial />} />
          <Route path="/environmental" element={<Environmental />} />
           <Route path="/packaging" element={<Packaging />} />
           <Route path="/food" element={<Food />} />
           <Route path="/admin/login" element={<AdminLogin />} />
           <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
  );
}

export default App;
